export default {
	data() {
		return {
			moduleName: 'roleGroups',
			detailPageRouteName: 'roleGroupsDetail',
			entityName: 'roleGroup',
			entity: {
				name: null,
				code: null,
				roles: {},
			},
			edit_allowed_section_list: [],
			updateFields: ['name', 'code', 'roles'],
		};
	},
	methods:{
		getEditAllowedSectionList(){
			this.setLoadingMessage();
			this.entityService.getEditAllowedSectionList()
				.then(data=> {
					this.edit_allowed_section_list = Object.values(data.edit_allowed_section_list);
					this.emptyMessage();
				}).catch(error => {
				this.setErrorMessage(error['error_message'])
			})
		},
	}
};



// WEBPACK FOOTER //
// ./src/components/views/roleGroups/mixins/roleGroups.js